import { submitForm } from "@components/Form/form-utils/submitForm"
import * as Sentry from "@sentry/gatsby"
import { useState } from "react"

const noop = () => {}

function useSubmit({
  shouldVerifyRecaptcha = false,
  shouldScheduleMeeting = true,
  shouldPostToNorthstar = false,
  rejectOnMarketoError = true,
  ...rest
} = {}) {
  const [submitted, setSubmitted] = useState(false)
  const [submissionFailed, setSubmissionFailed] = useState(false)
  const options = { shouldVerifyRecaptcha, shouldScheduleMeeting, shouldPostToNorthstar, rejectOnMarketoError, ...rest }

  async function handleSubmit(
    values,
    setSubmitting,
    recaptchaRef,
    { setFormError = noop, setFieldErrors = noop } = {}
  ) {
    if (submitted === true) {
      return
    }

    Sentry.setUser({
      email: values.Email,
    })

    try {
      await submitForm(values, { ...options, recaptchaRef })

      setSubmitting(false)
      setSubmitted(true)
      setSubmissionFailed(false)
    } catch (e) {
      setSubmitting(false)
      setSubmissionFailed(true)

      if (e instanceof Error) {
        switch (e?.cause?.code) {
          case "InvalidRecaptcha":
          case "ValidationErrors":
            setFormError("field-errors", { fields: Object.keys(e.cause.errors) })
            setFieldErrors(e.cause.errors)
            break
          case "SigSciError":
          case "NorthstarVpnError":
          case "NorthstarNetworkError":
          case "MarketoNetworkError":
            Sentry.setTag("fetch_status", e.cause.status)
            Sentry.captureException(e, { extra: e.cause })
            setFormError(e.cause.code)
            break
          case "SignupsDisabled":
          default:
            // display a generic alert banner
            Sentry.captureException(e, { extra: e.cause })
            setFormError(e.message)
            break
        }
      } else {
        // Unknown
        const newErr = new Error(e, { cause: { code: "UnhandledFormError" } })
        Sentry.captureException(newErr, { extra: newErr.cause })
        setFormError(e.message)
      }

      if (recaptchaRef?.current) {
        recaptchaRef.current.reset()
      }
    }
  }
  return { submitted, handleSubmit, submissionFailed, shouldPostToNorthstar }
}

export default useSubmit
